import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { HttpClient } from './http-client';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { dateToUnixTime } from '../utils/DateHelper';
import { DEFAULT_PAGE_SIZE } from './services-constants';
import * as moment from 'moment';

export const ACTIVITY_SCREEN_OWN = 'ACTIVITY_SCREEN_OWN';
export const ACTIVITY_SCREEN_MY_NETWORK = 'ACTIVITY_SCREEN_MY_NETWORK';
export const ACTIVITY_SCREEN_ALL = 'ACTIVITY_SCREEN_ALL';
export const ACTIVITY_SCREEN_COMUNICACION = 'ACTIVITY_SCREEN_COMUNICACION';

@Injectable()
export class ActividadService {



    public actividadPropiaLastAppliedFilters;
    public actividadMiRedLastAppliedFilters;
    public actividadTodosLastAppliedFilters;

    // unread activity bubbles variables
    private checkPropiaInterval;
    private checkRedInterval;
    private checkAllInterval;
    private checkPropiaFlag: boolean = false;
    private checkRedFlag: boolean = false;
    private checkAllFlag: boolean = false;
    private checkSource = new Subject<boolean>();
    checkFlag$ = this.checkSource.asObservable();

    private checkComunicacionInterval: any;
    private checkComunicacionFlag = false;
    private checkComunicacionSource = new Subject<boolean>();
    checkComunicacionFlag$ = this.checkComunicacionSource.asObservable();

    constructor(private httpClient: HttpClient,
                private router: Router) {

    }

    getActividad(screen: string,
      showConsignas: boolean,
      showCuentas: boolean,
      showPerfil: boolean,
      showNegocios: boolean,
      cuentasIds,
      contactosIds,
      colaboradoresIds,
      motoresIds,
      fromDate: Date,
      toDate: Date,
      page: number = 0
    ){

      let to = dateToUnixTime(toDate);
      let from = dateToUnixTime(fromDate);
      let userId = localStorage.getItem('userId');

      let request = {
        UserId: userId,
        PageSize: DEFAULT_PAGE_SIZE,
        PageNumber: page,
        Consignas: showConsignas,
        Cuentas: showCuentas,
        Perfil: showPerfil,
        Negocios: showNegocios,
        CuentasIds: cuentasIds,
        ContactosIds: contactosIds,
        ColaboradoresIds: colaboradoresIds,
        MotoresIds: motoresIds,
        From: from,
        To: to
      }

      let path = '';

      switch(screen){
        case ACTIVITY_SCREEN_OWN:
          path = `/api/actividad/me/all/`;
          break;
        case ACTIVITY_SCREEN_MY_NETWORK:
          path = `/api/actividad/me/my-network/all/`;
          break;
        case ACTIVITY_SCREEN_ALL:
          path = `/api/actividad/me/all/everyone/`;
          break;
      }

      return this.httpClient.post(path, request)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData.Result;
          }
      });
    }

    updateOwnLastAccess() {
      return this.httpClient.put('/api/actividad/me/last-access', {})
        .map((response: Response) => {
          return response.json();
        });
    }

    updateNetworkLastAccess() {
      return this.httpClient.put('/api/actividad/me/my-network/last-access', {})
        .map((response: Response) => {
          return response.json();
        });
    }

    updateEveryoneLastAccess() {
      return this.httpClient.put('/api/actividad/me/everyone/last-access', {})
        .map((response: Response) => {
          return response.json();
        });
    }

    updateComunicacionLastAccess() {
      return this.httpClient.put('/api/actividad/me/comunicacion/last-access', {})
        .map((response: Response) => {
          return response.json();
        });
    }

    checkNewActivitiesRequest(screen) {
      /*const fromDate = dateToUnixTime(moment().subtract(1,'week').toDate());
      const userId = localStorage.getItem('userId');

      //check activities once the user is logged in
      if(userId){

        let path = '';
        let backPath = userId + '/' + fromDate + '/';
        switch(screen){
          case ACTIVITY_SCREEN_OWN:
            path = `/api/actividad/are-new-me/` + backPath;
            break;
          case ACTIVITY_SCREEN_MY_NETWORK:
            path = `/api/actividad/are-new-my-network/` + backPath;
            break;
          case ACTIVITY_SCREEN_ALL:
            path = `/api/actividad/are-new-all/` + backPath;
            break;
        }

        return this.httpClient.get(path)
          .map((response: Response) => {
            if (response) {
              const data = response.json().ResponseData;
              return data;
            }
            return false;
        });
      } else{*/
        return Observable.from([]);
      /*}*/
    }

    checkNewComunicadosActivity() {
       const userId = localStorage.getItem('userId');
       // check activities once the user is logged in
       if (userId) {
         return this.httpClient.get(`/api/actividad/are-new-comunicacion-activity/${userId}`)
         .map((response: Response) => {
           if (response) {
             return response.json().ResponseData;
           }
         });
       } else {
         return Observable.from([]);
       }
    }

    // crear un intervcalo para chequear las actividades cada x cantidad de tiempo (fuera de uso, se reutiliza para el
    // modulo de comunicados como un aparte, si se requiere volver a utilizar esta funcion se agrega a la logica
    // de la misma manera en que funcionaba antes, en conjunto con actividades)
    checkNewActivities() {
      this.checkPropiaFlag = false;
      this.checkRedFlag = false;
      this.checkAllFlag = false;
      this.checkComunicacionFlag = false;
      this.cancelCheckActivities();

      this.checkNewActivitiesRequest(ACTIVITY_SCREEN_OWN).subscribe(value => {
        this.checkPropiaFlag = value;
        this.checkSource.next(this.checkPropiaFlag || this.checkRedFlag || this.checkAllFlag);
      });
      this.checkNewActivitiesRequest(ACTIVITY_SCREEN_MY_NETWORK).subscribe(value => {
        this.checkRedFlag = value;
        this.checkSource.next(this.checkPropiaFlag || this.checkRedFlag || this.checkAllFlag);
      });
      this.checkNewActivitiesRequest(ACTIVITY_SCREEN_ALL).subscribe(value => {
        this.checkAllFlag = value;
        this.checkSource.next(this.checkPropiaFlag || this.checkRedFlag || this.checkAllFlag);
      });
      this.checkNewComunicadosActivity()
        .subscribe(value => {
          this.checkComunicacionFlag = value;
          this.checkComunicacionSource.next(this.checkComunicacionFlag);
        });

      this.checkPropiaInterval = setInterval(() => {
        this.checkNewActivitiesRequest(ACTIVITY_SCREEN_OWN).subscribe(value => {
          this.checkPropiaFlag = value;
          this.checkSource.next(this.checkPropiaFlag || this.checkRedFlag || this.checkAllFlag);
        });
      }, 1 * 30 * 1000);
      this.checkRedInterval = setInterval(() => {
        this.checkNewActivitiesRequest(ACTIVITY_SCREEN_MY_NETWORK).subscribe(value => {
          this.checkRedFlag = value;
          this.checkSource.next(this.checkPropiaFlag || this.checkRedFlag || this.checkAllFlag);
        });
      }, 2 * 60 * 1000);
      this.checkAllInterval = setInterval(() => {
        this.checkNewActivitiesRequest(ACTIVITY_SCREEN_ALL).subscribe(value => {
          this.checkAllFlag = value;
          this.checkSource.next(this.checkPropiaFlag || this.checkRedFlag || this.checkAllFlag);
        });
      }, 4 * 60 * 1000);
      this.checkComunicacionInterval = setInterval(() => {
        this.checkNewComunicadosActivity()
          .subscribe(value => {
            this.checkComunicacionFlag = value;
            this.checkComunicacionSource.next(this.checkComunicacionFlag);
          });
      }, 30 * 1000);
    }

    getActivityFlag(screen) {
      switch(screen){
        case ACTIVITY_SCREEN_OWN:
          return this.checkPropiaFlag;
        case ACTIVITY_SCREEN_MY_NETWORK:
          return this.checkRedFlag;
        case ACTIVITY_SCREEN_ALL:
          return this.checkAllFlag;
        case ACTIVITY_SCREEN_COMUNICACION:
          return this.checkComunicacionFlag;
      }
    }

    setActivityFlag(screen, value) {
      switch(screen){
        case ACTIVITY_SCREEN_OWN:
          this.checkPropiaFlag = value;
          break;
        case ACTIVITY_SCREEN_MY_NETWORK:
          this.checkRedFlag = value;
          break;
        case ACTIVITY_SCREEN_ALL:
          this.checkAllFlag = value;
          break;
        case ACTIVITY_SCREEN_COMUNICACION:
          this.checkComunicacionFlag = value;
      }
      this.checkSource.next(this.checkPropiaFlag || this.checkRedFlag || this.checkAllFlag);
      this.checkComunicacionSource.next(this.checkComunicacionFlag);
    }

    cancelCheckActivities() {
      clearInterval(this.checkPropiaInterval);
      clearInterval(this.checkRedInterval);
      clearInterval(this.checkAllInterval);
      clearInterval(this.checkComunicacionInterval);
    }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/actividad-service.ts